import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationDashboardReducer} from '../../utils/types';
//actions
import {
	getDashboardAttentionList,
	getDashboardAuctionItems,
	getDashboardCheckedIn,
	getDashboardSpecialMeals,
	getDashboardStatistics,
	getDashboardTablesSold,
	getDashboardUnknownGuests,
} from './actions';
//operations
import {
	pendingOperation,
	rejectedOperation,
	getStatisticsOperation,
	getDashboardTablesSoldOperation,
	getDashboardUnknownGuestsOperation,
	getDashboardAuctionItemsOperation,
	getDashboardCheckedInOperation,
	getDashboardSpecialMealsOperation,
	clearDashboardDataOperation,
	getDashboardAttentionListDataOperation,
} from './operations';
//constants
import {initialOrganizationData} from '@/utils/constants';

export const initialState: IOrganizationDashboardReducer = {
	statistics: null,
	tablesSold: initialOrganizationData,
	unknownGuests: initialOrganizationData,
	auctionItems: initialOrganizationData,
	checkedIn: initialOrganizationData,
	specialMeals: initialOrganizationData,
	attentionList: [],
	isLoading: false,
};

const organizationDashboardStore = createSlice({
	name: 'organizationDashboard',
	initialState,
	reducers: {
		clearDashboardData: (state) => clearDashboardDataOperation(state, initialState),
	},
	extraReducers: (builder) => {
		builder.addCase(getDashboardStatistics.pending, pendingOperation);
		builder.addCase(getDashboardStatistics.fulfilled, getStatisticsOperation);
		builder.addCase(getDashboardStatistics.rejected, rejectedOperation);

		builder.addCase(getDashboardTablesSold.pending, pendingOperation);
		builder.addCase(getDashboardTablesSold.fulfilled, getDashboardTablesSoldOperation);
		builder.addCase(getDashboardTablesSold.rejected, rejectedOperation);

		builder.addCase(getDashboardUnknownGuests.pending, pendingOperation);
		builder.addCase(getDashboardUnknownGuests.fulfilled, getDashboardUnknownGuestsOperation);
		builder.addCase(getDashboardUnknownGuests.rejected, rejectedOperation);

		builder.addCase(getDashboardAuctionItems.pending, pendingOperation);
		builder.addCase(getDashboardAuctionItems.fulfilled, getDashboardAuctionItemsOperation);
		builder.addCase(getDashboardAuctionItems.rejected, rejectedOperation);

		builder.addCase(getDashboardCheckedIn.pending, pendingOperation);
		builder.addCase(getDashboardCheckedIn.fulfilled, getDashboardCheckedInOperation);
		builder.addCase(getDashboardCheckedIn.rejected, rejectedOperation);

		builder.addCase(getDashboardSpecialMeals.pending, pendingOperation);
		builder.addCase(getDashboardSpecialMeals.fulfilled, getDashboardSpecialMealsOperation);
		builder.addCase(getDashboardSpecialMeals.rejected, rejectedOperation);

		builder.addCase(getDashboardAttentionList.pending, pendingOperation);
		builder.addCase(getDashboardAttentionList.fulfilled, getDashboardAttentionListDataOperation);
		builder.addCase(getDashboardAttentionList.rejected, rejectedOperation);
	},
});

export const {clearDashboardData} = organizationDashboardStore.actions;

export default organizationDashboardStore.reducer;
